<template>
  <code-preview
    v-if="code"
    :code="code"
    :code-label="props.item.fields?.codeLabel ?? ''"
    :language="codingLanguage"
    :copy-value="copyValue"
    :copy-text="$textDictionary['codeBlock.button.copyLabel']"
    :copied-text="$textDictionary['codeBlock.button.copiedLabel']"
    :copy-error-text="$textDictionary['codeBlock.button.copyLabel']"
    :variant="variant"
    :show-copy-button="showCopyButton"
    :color-mode="colorMode"
  />
</template>

<script setup lang="ts">
import { CodePreview } from '@hypercodestudio/basler-components';
import type { ICodeBlock } from '~~/lib/ContentfulService';
const { $textDictionary } = useNuxtApp();

interface Props {
  item: ICodeBlock;
}

const props = defineProps<Props>();

const code = computed(() => props.item.fields.code);
const copyValue = computed(
  () => props.item.fields.copyValue ?? props.item.fields.code
);
const variant = computed(() => props.item.fields.variant);

const codingLanguage = computed(
  () => props.item.fields?.codingLanguage ?? 'bash'
);
const colorMode = computed(() => {
  return props.item.fields?.colorMode === 'default'
    ? undefined
    : props.item.fields?.colorMode;
});
const showCopyButton = computed(
  () => props.item.fields?.showCopyButton ?? true
);
</script>
